import { formatCurrency } from '@/routes/_dashboard/dashboard/estimates/_shared';
import {
  taxBreakdownDisplayMeta,
  taxBreakdownDisplayName,
  type AggregatedTaxBreakdownRow,
} from '@/lib/tax/tax-utils';

interface EstimateLiteSummaryCardProps {
  customerName: string;
  addressLine?: string;
  itemCount: number;
  subtotal: number;
  taxTotal: number;
  taxBreakdown: AggregatedTaxBreakdownRow[];
  grandTotal: number;
}

export function EstimateLiteSummaryCard({
  customerName,
  addressLine,
  itemCount,
  subtotal,
  taxTotal,
  taxBreakdown,
  grandTotal,
}: EstimateLiteSummaryCardProps) {
  return (
    <div className="space-y-2">
      <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">Summary</p>
      <div className="space-y-1.5 rounded-lg border bg-muted/40 p-3 text-sm">
        <div className="flex justify-between">
          <span className="text-muted-foreground">Customer</span>
          <span className="font-medium">{customerName}</span>
        </div>
        {addressLine && (
          <div className="flex justify-between">
            <span className="text-muted-foreground">Address</span>
            <span className="max-w-[60%] truncate text-right font-medium">{addressLine}</span>
          </div>
        )}
        <div className="flex justify-between">
          <span className="text-muted-foreground">Items</span>
          <span className="font-medium">{itemCount}</span>
        </div>
        <div className="mt-1.5 flex justify-between border-t pt-1.5">
          <span className="text-muted-foreground">Subtotal</span>
          <span className="font-medium">{formatCurrency(subtotal)}</span>
        </div>
        {taxTotal > 0 &&
          (taxBreakdown.length > 0 ? (
            taxBreakdown.map((row, index) => (
              <div
                key={`${row.primary}-${row.secondary ?? ''}-${row.jurisdictionType ?? ''}-${row.rate}-${index}`}
                className="flex items-start justify-between gap-3"
              >
                <span className="flex min-w-0 flex-col text-muted-foreground">
                  <span>{taxBreakdownDisplayName(row)}</span>
                  <span className="text-xs text-muted-foreground/70">
                    {taxBreakdownDisplayMeta(row)}
                  </span>
                </span>
                <span className="font-medium">{formatCurrency(row.amount)}</span>
              </div>
            ))
          ) : (
            <div className="flex justify-between">
              <span className="text-muted-foreground">Tax</span>
              <span className="font-medium">{formatCurrency(taxTotal)}</span>
            </div>
          ))}
        <div className="mt-0.5 flex justify-between border-t pt-1.5">
          <span className="font-semibold">Total</span>
          <span className="font-semibold">{formatCurrency(grandTotal)}</span>
        </div>
      </div>
    </div>
  );
}
